/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react'
import React from 'react'

import { getMarginInRems } from '../../utils/style/separator'
import { useIsOn } from '../../utils/contexts/ResponsiveProvider'

const SeparatorWrapper = ({ weight, weightOnSm, usePadding, height, ...props }) => {
  const isOnSm = useIsOn('sm')
  const smWeight = isOnSm && weightOnSm
  const distance = getMarginInRems(smWeight || weight)
  const style = css`
    ${usePadding ? 'padding' : 'margin'}: ${distance}rem;
    height: ${height};
  `

  return <div css={style} {...props} />
}

export default SeparatorWrapper
